// Core
import React from 'react';

function Icon(): JSX.Element {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="circle-icon"
    >
      <circle
        cx="10.3772"
        cy="10.2869"
        r="9.28101"
        stroke="currentColor"
        strokeWidth={2}
      />
    </svg>
  );
}

export default Icon;
